<template>
  <div>
    <card class="col-lg-12 col-md-12" :class="'card-'+theme" v-if="!$auth.user().subscription">
      <div class="card-header">
        <h4 class="card-title">
          <i class="nc-icon nc-notification-70"></i> Oops!
        </h4>
      </div>
      <hr />
      <div class="card-body">
        <div class="text-center">
          <h2 class="card-title text-center">
            <small>Wall Street, we have a problem...</small>
          </h2>
          <h2 class="card-title text-center">
            <small>Você não possui assinatura ativa para utilizar as ferramentas de Trading System.</small>
          </h2>
          <br />
          <router-link
            class="btn btn-round btn-fill"
            :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
            to="/signature"
            href="/performance"
          >Nova Assinatura</router-link>
        </div>
      </div>
    </card>

    <div class="row" v-if="$auth.user().subscription">
      <stats-card class="col-md-4 col-lg-4 text-left">
        <div slot="header">
          <i class="fa fa-donate icon" :class="' icon-orange-'+theme"></i>
        </div>
        <template slot="content">
          <p class="card-title">Minha Banca na Corretora:</p>
          $ {{ bankroll }}
        </template>
        <template slot="footer">
          <button
            class="btn btn-round btn-fill"
            :class=" theme === 'black' ? 'btn-azure':'btn-primary' "
            @click="openModal('deposit')"
          >Depositei</button>
          <el-dialog center title="Depositei" :visible.sync="modals.deposit">
            <span>
              <card class="stacked-form">
                <form method="#" action="#" @submit.prevent>
                  <div>
                    <fg-input
                      label="Entre com o valor depositado na Corretora:"
                      type="number"
                      step="any"
                      v-model="depositEntry"
                      placeholder="Ex. ###,##"
                    ></fg-input>
                    <button
                      type="submit"
                      class="btn btn-round btn-primary btn-fill"
                      @click.prevent="deposit()"
                    >Salvar</button>
                  </div>
                </form>
              </card>
            </span>
          </el-dialog>
          <button
            class="btn btn-round btn-fill"
            :class=" theme === 'black' ? 'btn-red2':'btn-warning' "
            @click="openModal('withdraw')"
          >Saquei</button>
          <el-dialog center title="Saquei" :visible.sync="modals.withdraw">
            <span>
              <card class="stacked-form">
                <form method="#" action="#" @submit.prevent>
                  <div>
                    <fg-input
                      label="Entre com o valor sacado na Corretora:"
                      type="number"
                      step="any"
                      v-model="withdrawEntry"
                      placeholder="Ex. ###,##"
                    ></fg-input>
                    <button
                      type="submit"
                      class="btn btn-round btn-primary btn-fill"
                      @click.prevent="withdraw()"
                    >Salvar</button>
                  </div>
                </form>
              </card>
            </span>
          </el-dialog>
        </template>
      </stats-card>
      <stats-card class="col-md-4 col-lg-4 text-left">
        <div slot="header">
          <i class="fa fa-money-check-alt icon" :class="'icon-green-'+theme"></i>
        </div>
        <template slot="content">
          <p class="card-title">Meus Rendimentos:</p>
          Hoje: $ {{ todayProfit }}
          <br />
          Semana: $ {{ weekProfit }}
        </template>
        <template slot="footer">
          <button
            class="btn btn-round btn-fill"
            :class=" theme === 'black' ? 'btn-azure':'btn-primary' "
            @click="openModal('statement')"
          >
            <i class="nc-icon nc-paper-2"></i> Extrato
          </button>
          <el-dialog center title="Extrato" fullscreen :visible.sync="modals.statement">
            <span>
              <card class="stacked-form">
                <vue-tabs>
                  <v-tab title="Hoje">
                    <div class="card-header row col-md-12">
                      <h5 class="card-title col-md-6">
                        <i class="nc-icon nc-paper-2"></i> Movimentação:
                      </h5>
                      <h5 class="card-title col-md-6">
                        <i class="nc-icon nc-money-coins"></i>
                        Rendimento: $ {{ todayProfit }}
                      </h5>
                    </div>
                    <div class="card-body">
                      <h5 class="card-title table-responsive">
                        <table class="table">
                          <tr v-for="(order, index) in todaysOrders" :key="order.id">
                            <td width="50%">
                              <div v-if="order.kind!=='order'">
                                {{ order.kind === "deposit" ? "Depósito" : "" }}
                                {{ order.kind === "withdraw" ? "Saque" : "" }}
                                {{ order.kind === "adjust" ? "Ajuste" : "" }}
                              </div>
                              <div
                                :class="((order.bankroll - order.old_bankroll) > 0) ? 'text-success' : 'text-danger'"
                                v-if="order.kind==='order'"
                              >{{ (order.bankroll - order.old_bankroll) > 0 ? "Win" : "Loss" }}</div>
                            </td>
                            <td width="50%">
                              <small>Data:</small>
                              {{order.created_at | moment("DD/MM/YYYY H:mm:ss")}}
                              <br />
                              <small>Retorno:</small>
                              $ {{ Number.parseFloat(order.bankroll - order.old_bankroll).toFixed(2) }}
                              <div v-if="order.kind==='order'">
                                <small>Payout:</small>
                                {{ order.payout }}%
                                <br />
                                <small>Ordem:</small>
                                $ {{ Number.parseFloat(order.entry).toFixed(2) }}
                              </div>
                            </td>
                          </tr>
                        </table>
                      </h5>
                    </div>
                  </v-tab>
                  <v-tab title="Semana">
                    <div class="card-header row col-md-12">
                      <h5 class="card-title col-md-6">
                        <i class="nc-icon nc-paper-2"></i> Movimentação:
                      </h5>
                      <h5 class="card-title col-md-6">
                        <i class="nc-icon nc-money-coins"></i>
                        Rendimento: $ {{ weekProfit }}
                      </h5>
                    </div>
                    <div class="card-body">
                      <h5 class="card-title table-responsive">
                        <table class="table">
                          <tr v-for="(order, index) in lastWeekOrders" :key="order.id">
                            <td width="50%">
                              <div v-if="order.kind!=='order'">
                                {{ order.kind === "deposit" ? "Depósito" : "" }}
                                {{ order.kind === "withdraw" ? "Saque" : "" }}
                                {{ order.kind === "adjust" ? "Ajuste" : "" }}
                              </div>
                              <div
                                :class="((order.bankroll - order.old_bankroll) > 0) ? 'text-success' : 'text-danger'"
                                v-if="order.kind==='order'"
                              >{{ (order.bankroll - order.old_bankroll) > 0 ? "Win" : "Loss" }}</div>
                            </td>
                            <td width="50%">
                              <small>Data:</small>
                              {{order.created_at | moment("DD/MM/YYYY H:mm:ss")}}
                              <br />
                              <small>Retorno:</small>
                              $ {{ Number.parseFloat(order.bankroll - order.old_bankroll).toFixed(2) }}
                              <div v-if="order.kind==='order'">
                                <small>Payout:</small>
                                {{ order.payout }}%
                                <br />
                                <small>Ordem:</small>
                                $ {{ Number.parseFloat(order.entry).toFixed(2) }}
                              </div>
                            </td>
                          </tr>
                        </table>
                      </h5>
                    </div>
                  </v-tab>
                  <v-tab title="Personalizado">
                    <div class="row extended-forms">
                      <div class="col-md-6">
                        <h4 class="title">De:</h4>
                        <fg-input>
                          <el-date-picker
                            v-model="initDatePicker"
                            type="date"
                            placeholder="Escolha data aqui"
                            :picker-options="pickerOptions1"
                          ></el-date-picker>
                        </fg-input>
                      </div>
                      <div class="col-md-6">
                        <h4 class="title">Até:</h4>
                        <fg-input>
                          <el-date-picker
                            v-model="finalDatePicker"
                            type="date"
                            placeholder="Escolha data aqui"
                            :picker-options="pickerOptions1"
                          ></el-date-picker>
                        </fg-input>
                      </div>
                      <div class="offset-md-6 col-md-6">
                        <button
                          type="submit"
                          class="btn btn-fill btn-info pull-right"
                          :disabled="!(initDatePicker&&finalDatePicker)"
                          @click.prevent="fetchCustomSearch()"
                        >
                          <i class="nc-icon nc-zoom-split"></i> Consultar
                        </button>
                      </div>
                    </div>
                    <div class="card-header row col-md-12">
                      <h5 class="card-title col-md-6">
                        <i class="nc-icon nc-paper-2"></i> Movimentação:
                      </h5>
                      <h5 class="card-title col-md-6">
                        <i class="nc-icon nc-money-coins"></i>
                        Rendimento: $ {{ customProfit }}
                      </h5>
                    </div>
                    <div class="card-body">
                      <h5 class="card-title table-responsive">
                        <div
                          class="text-center"
                          v-if="loadingCustomTradingSystemData"
                          v-loading="loadingCustomTradingSystemData"
                          id="loading"
                        ></div>
                        <table class="table" v-if="!loadingCustomTradingSystemData">
                          <tr v-for="(order, index) in customOrders" :key="order.id">
                            <td width="50%">
                              <div v-if="order.kind!=='order'">
                                {{ order.kind === "deposit" ? "Depósito" : "" }}
                                {{ order.kind === "withdraw" ? "Saque" : "" }}
                                {{ order.kind === "adjust" ? "Ajuste" : "" }}
                              </div>
                              <div
                                :class="((order.bankroll - order.old_bankroll) > 0) ? 'text-success' : 'text-danger'"
                                v-if="order.kind==='order'"
                              >{{ (order.bankroll - order.old_bankroll) > 0 ? "Win" : "Loss" }}</div>
                            </td>
                            <td width="50%">
                              <small>Data:</small>
                              {{order.created_at | moment("DD/MM/YYYY H:mm:ss")}}
                              <br />
                              <small>Retorno:</small>
                              $ {{ Number.parseFloat(order.bankroll - order.old_bankroll).toFixed(2) }}
                              <div v-if="order.kind==='order'">
                                <small>Payout:</small>
                                {{ order.payout }}%
                                <br />
                                <small>Ordem:</small>
                                $ {{ Number.parseFloat(order.entry).toFixed(2) }}
                              </div>
                            </td>
                          </tr>
                        </table>
                      </h5>
                    </div>
                  </v-tab>
                </vue-tabs>
              </card>
            </span>
          </el-dialog>
        </template>
      </stats-card>
      <stats-card class="col-md-4 col-lg-4 text-left">
        <div slot="header" class="icon-warning">
          <i class="fa fa-chart-line icon" :class="' icon-blue-'+theme"></i>
        </div>
        <template slot="content" @click.prevent="cleanOrders()">
          <p class="card-title">Catalogador de Velas & Ciclos </p>
            <div style="line-height: 10px !important; color: #ccc">
              <small>
                Esta ferramenta é destinada à catalogação de velas e ciclos da Teoria Cutrim.
                O uso do conhecimento gerado pela mesma é de sua inteira responsabilidade.
              </small>
            </div>
        </template>
        <template slot="footer">
            <router-link
              type="submit"
              class="btn btn-fill btn-round"
              :class=" theme === 'black' ? 'btn-azure':'btn-primary' "
              :to="{ name: 'Catalogação Teoria Cutrim' }"
              target="_blank"
            >Automatico
            </router-link>
            <router-link
              type="submit"
              class="btn btn-round btn-outlined"
              :class=" theme === 'black' ? 'btn-azure':'btn-primary' "
              :to="{ name: 'New Catalogação Manual Teoria Cutrim' }"
              target="_blank"
            >Manual
            </router-link>
        </template>
      </stats-card>

      <!-- TRADING SYSTEM CALCULATOR -->
      <div class="col-md-12 col-sm-12 px-0">
        <orders-calculator />
      </div>

    </div>
    <!-- Grafico -->
    <div class="row">
      <div class="col-md-12 col-lg-12" style="padding: 0px 0px 0px 0px" >
        <div class="row"  v-if="loadingLastWeekOrders" v-loading="loadingLastWeekOrders" id="loading"></div>
        <chart-card :class="'card-'+theme" v-if="!loadingLastWeekOrders" :chart-data="lineChart.data" :chart-options="lineChart.options" :responsive-options="lineChart.responsiveOptions">
          <template slot="header" >
            <h5 class="card-title" :class="'card-title-'+theme">Gráfico de Evolução Financeira</h5>
            <p class="card-category" :class="'card-category-'+theme">[Banca em $ x Período]<br />Rendimentos: Hoje: ${{ todayProfit }} | Esta Semana: ${{ weekProfit }}</p>
          </template>
          <template slot="footer">
            <hr>
            <div class="stats" :class="'card-title-'+theme">
              <i class="fa fa-history"></i> Dados dos últimos 7 dias
            </div>
          </template>
        </chart-card>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import VueTabs from "vue-nav-tabs";
import VueClipboard from "vue-clipboard2";
import OrdersCalculator from './OrdersCalculator'

import {
  Loading,
  Dialog,
  Select,
  Option,
  Slider,
  DatePicker
} from "element-ui";
import {
  StatsCard,
  Card,
  ChartCard,
  Switch as LSwitch,
  FormGroupInput as FgInput
} from "src/components/index";

Vue.use(Loading.directive, VueTabs);
Vue.use(VueClipboard);

export default {
  components: {
    FgInput,
    Card,
    ChartCard,
    StatsCard,
    OrdersCalculator,
    LSwitch,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Slider.name]: Slider,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      modals: {
        deposit: false,
        withdraw: false,
        statement: false,
        catalog: false
      },
      // bankroll: "",
      // weekProfit: "",
      // todayProfit: "",
      loadingLastWeekOrders: false,
      lineChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: false,
          height: "245px",
          axisX: {
            showGrid: false
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },
      orders: [],
      lastWeekOrders: [],
      todaysOrders: [],
      customOrders: [],
      bankroll: 0,
      bankrollEntry: 0,
      depositEntry: 0,
      withdrawEntry: 0,
      weekProfit: 0,
      todayProfit: 0,
      customProfit: 0,
      payoutPercent: 90,
      profitPercent: 1,
      payoutContinued: false,
      loadingTradingSystemData: true,
      loadingSaveOrder: false,
      loadingCustomTradingSystemData: false,
      entries: [],
      totalRisk: 0,
      payoutChange: [],
      ordersMessage: "",
      switches: {
        martingale: false,
        payoutChange: false,
        simulator: false
      },
      sliders: {
        martingale: 3
      },
      pickerOptions1: {
        shortcuts: [
          {
            text: "Hoje",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "Ontem",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "Semana passada",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      initDatePicker: "",
      finalDatePicker: "",
      dateTimePicker: "",
      timePicker: "",
      howManyCandles: "",
      selectedAsset: "",
      selectedCandleTime: "",
      initCatalogTime: "",
      selects: {}
    };
  },
  methods: {
    fetchLastWeekOrdersGrafic() {
      this.loadingLastWeekOrders = true;
      this.axios
      .get('/orders/lastweek')
      .then(response => {
        let labels = []
        let serie = []
        this.weekProfit = 0
        if (response.data.orders) {
          let orders = response.data.orders

          for (let i = orders.length - 1; i >= 0; i--) {
            serie.push(parseFloat(orders[i].bankroll))
            labels.push(moment(orders[i].created_at).locale('pt-br').calendar().toString())
            if (orders[i].kind === 'order') {
              this.weekProfit += (orders[i].bankroll - orders[i].old_bankroll)
            }
          }
          this.weekProfit = Number.parseFloat(this.weekProfit + '').toFixed(2)
          // this.lineChart.data.labels = labels
          this.lineChart.data.series.push(serie)
          console.log(this.lineChart.data.series)
        }
        this.loadingLastWeekOrders = false
      })
      .catch(error => {
        console.log(error)
        this.loadingLastWeekOrders = false
      })
    },
    fetchOrders() {
      this.loadingTradingSystemData = true;
      this.axios
        .get("/orders")
        .then(response => {
          this.orders = response.data;
          if (this.orders.length > 0) {
            this.bankroll = this.orders[0].bankroll;
            this.bankrollEntry = this.bankroll;
            this.loadingTradingSystemData = false;
            this.fetchLastWeekOrders();
            this.fetchTodaysOrders();
          } else {
            if (this.$auth.user().subscription) {
              this.notify(
                `Informe um depósito em sua banca para utilizar a calculadora.`
              );
              this.notifyVue("top", "center", "danger", "nc-simple-remove");
            }
          }
        })
        .catch(error => {
          console.log(error);
          this.loadingTradingSystemData = false;
          alert(
            "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
              error
          );
        });
    },
    fetchLastWeekOrders() {
      this.axios
        .get("/orders/lastweek")
        .then(response => {
          if (response.data.orders) {
            this.lastWeekOrders = response.data.orders;
            this.weekProfit = 0;
            this.lastWeekOrders.map(order => {
              if (order.kind === "order") {
                this.weekProfit += order.bankroll - order.old_bankroll;
              }
            });
            this.weekProfit = Number.parseFloat(this.weekProfit + "").toFixed(
              2
            );
          } else {
            this.weekProfit = 0;
          }
        })
        .catch(error => {
          this.weekProfit = 0;
          console.log(error);
          alert(
            "Erro ao carregar dados de Trading System. Entre em contato com o suporte" +
              error
          );
        });
    },
    fetchTodaysOrders() {
      this.axios
        .get("/orders/today")
        .then(response => {
          if (response.data.orders) {
            this.todaysOrders = response.data.orders;
            this.todayProfit = 0;
            this.todaysOrders.map(order => {
              if (order.kind === "order") {
                this.todayProfit += order.bankroll - order.old_bankroll;
              }
            });
            this.todayProfit = Number.parseFloat(this.todayProfit + "").toFixed(
              2
            );
          } else {
            this.todayProfit = 0;
          }
        })
        .catch(error => {
          this.todayProfit = 0;
          console.log(error);
          alert(
            "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
              error
          );
        });
    },
    fetchCustomSearch() {
      this.loadingCustomTradingSystemData = true;
      this.initDatePicker = moment(this.initDatePicker).format("DD/MM/YYYY");
      this.finalDatePicker = moment(this.finalDatePicker).format("DD/MM/YYYY");

      let customSearchData = {
        startDate: this.initDatePicker,
        endDate: this.finalDatePicker
      };

      this.initDatePicker = "";
      this.finalDatePicker = "";

      this.axios
        .patch("/orders/customsearch", customSearchData)
        .then(response => {
          this.loadingCustomTradingSystemData = false;
          if (response.data.orders) {
            this.customOrders = response.data.orders;
            this.customProfit = 0;
            this.customOrders.map(order => {
              if (order.kind === "order") {
                this.customProfit += order.bankroll - order.old_bankroll;
              }
            });
            this.customProfit = Number.parseFloat(
              this.customProfit + ""
            ).toFixed(2);
          } else {
            this.customProfit = 0;
          }
        })
        .catch(error => {
          this.loadingCustomTradingSystemData = false;
          this.customProfit = 0;
          console.log(error);
          alert(
            "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
              error
          );
        });
    },
    cleanOrders() {
      this.switches.martingale = false;
      this.totalRisk = 0;
      this.entries = [];
      this.fetchOrders();
    },
    isMartingale(entry) {
      return entry.id > 1;
    },
    isFirst(entry) {
      return entry.id === this.entries[0].id;
    },
    isDangerMartingale(entry) {
      return entry.id > 3;
    },
    profit() {
      return this.profitPercent / 100;
    },
    payout() {
      return this.payoutPercent / 100;
    },
    lastLossOrZero() {
      const lastEntry = this.entries.slice(-1).pop();
      return lastEntry !== undefined ? lastEntry.loss : 0;
    },
    emptyBankroll() {
      return this.bankroll < 1;
    },
    notify(message) {
      this.ordersMessage = message;
    },
    notifyVue(verticalAlign, horizontalAlign, color, icon) {
      let message = this.ordersMessage;
      this.$notify({
        component: {
          template: `<h5 class="card-title">${message}</h5>`
        },
        icon: "nc-icon " + icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color
      });
    },
    openModal(name) {
      this.depositEntry = 0;
      this.withdrawEntry = 0;
      this.modals[name] = true;
    },
    closeModal(name) {
      this.depositEntry = 0;
      this.withdrawEntry = 0;
      this.modals[name] = false;
    },
    deposit() {
      let amount = this.depositEntry;
      this.axios
        .post("/orders?kind=deposit", { amount })
        .then(response => {
          this.notify("Depósito salvo com sucesso!");
          this.notifyVue("top", "center", "primary", "nc-check-2");
          this.closeModal("deposit");
          this.fetchOrders();
        })
        .catch(error => {
          this.closeModal("deposit");
          console.log(error);
          alert(
            "Erro ao salvar operação de depósito. Entre em contato o suporte: " +
              error
          );
        });
    },
    withdraw() {
      let amount = this.withdrawEntry;
      this.axios
        .post("/orders?kind=withdraw", { amount })
        .then(response => {
          this.notify("Saque salvo com sucesso!");
          this.notifyVue("top", "center", "primary", "nc-check-2");
          this.closeModal("withdraw");
          this.fetchOrders();
        })
        .catch(error => {
          this.closeModal("withdraw");
          console.log(error);
          alert(
            "Erro ao salvar operação de saque. Entre em contato o suporte: " +
              error
          );
        });
    },
    calculateOrder() {
      if (this.payoutContinued == false) {
        this.entries = [];
        while (
          this.entries.length === 0 ||
          (this.switches.martingale &&
            this.entries.length < this.sliders.martingale)
        ) {
          const entry = {};
          entry.id = this.entries.length + 1;
          entry.order = (
            this.bankrollEntry *
            ((this.profit() + this.lastLossOrZero() / 100) / this.payout())
          ).toFixed(2);
          entry.return = (entry.order * this.payout()).toFixed(2);
          entry.profit = this.bankrollEntry * this.profit;
          entry.win = this.profitPercent;
          entry.loss =
            (entry.order / this.bankrollEntry) * 100 + this.lastLossOrZero();
          entry.payout = this.payoutPercent;
          if (entry.loss > 100) {
            break;
          } else {
            this.totalRisk = entry.loss;
          }

          this.entries.push(entry);
        }
      } else {
        if (this.entries.length > 0) {
          if (this.entries[0].id != 1) {
            if (this.entries[0].payout != this.payoutPercent) {
              if (this.entries.length > 0) {
                var payoutPercent = this.payoutPercent;
                var bankrollEntry = this.bankrollEntry;
                var lastLossOrZero = this.lastLossOrZero();
                var previusReturn, previusOrder;
                this.entries.forEach(function(data, index) {
                  if (index > 0) {
                    data.return =
                      parseFloat(previusReturn) + parseFloat(previusOrder);
                    previusReturn = data.return;
                  } else {
                    previusReturn = data.return;
                  }
                  data.order = ((data.return / payoutPercent) * 100).toFixed(2);
                  previusOrder = data.order;
                  data.payout = payoutPercent;
                  data.loss =
                    (data.order / bankrollEntry) * 100 + lastLossOrZero;
                });
                this.totalRisk = this.entries[this.entries.length - 1].loss;
              }
            } else {
              this.payoutContinued = true;
              this.notify(
                `Mudança de Payout: Verifique Se Houve Mudança no Campo Payout!`
              );
              this.notifyVue("top", "center", "danger", "nc-simple-remove");
            }
          } else {
            this.payoutContinued = true;
            this.notify(
              `Mudança de Payout: Nenhuma Ordem Anterior Realizada. Recalcule!`
            );
            this.notifyVue("top", "center", "danger", "nc-simple-remove");
          }
        } else {
          this.payoutContinued = true;
          this.notify(
            `Mudança de Payout: Nenhuma Ordem Para Realizar Mudança. Recalcule!`
          );
          this.notifyVue("top", "center", "danger", "nc-simple-remove");
        }
      }
    },
    doOrder(win) {
      this.loadingSaveOrder = true;
      if (this.bankroll === this.bankrollEntry) {
        const entry = this.entries.shift();
        if (win) this.entries = [];
        this.axios
          .post("/orders?kind=order", { entry, win })
          .then(data => {
            this.notify("Ordem salva com sucesso!");
            this.notifyVue("top", "center", "primary", "nc-check-2");
            this.axios
              .get("/orders")
              .then(response => {
                this.loadingSaveOrder = false;
                this.orders = response.data;
                if (this.orders.length > 0) {
                  this.bankroll = this.orders[0].bankroll;
                  this.bankrollEntry = this.bankroll;
                  this.fetchLastWeekOrders();
                  this.fetchTodaysOrders();
                  if (win) {
                    this.calculateOrder();
                  }
                }
              })
              .catch(error => {
                this.loadingSaveOrder = false;
                console.log(error);
                alert(
                  "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
                    error
                );
              });
          })
          .catch(error => {
            console.log(error.message);
            alert(
              "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
                error.message
            );
          });
      } else {
        // Init Adjust Loading Here.
        let amount = this.bankrollEntry;
        this.axios
          .post("/orders?kind=adjust", { amount })
          .then(data => {
            const entry = this.entries.shift();
            if (win) this.entries = [];
            this.axios
              .post("/orders?kind=order", { entry, win })
              .then(data => {
                this.loadingSaveOrder = false;
                this.notify("Ordem salva com sucesso!");
                this.notifyVue("top", "center", "primary");
                this.axios
                  .get("/orders")
                  .then(response => {
                    this.orders = response.data;
                    if (this.orders.length > 0) {
                      this.bankroll = this.orders[0].bankroll;
                      this.bankrollEntry = this.bankroll;
                      this.fetchLastWeekOrders();
                      this.fetchTodaysOrders();
                      if (win) {
                        this.calculateOrder();
                      }
                    }
                  })
                  .catch(error => {
                    console.log(error);
                    alert(
                      "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
                        error
                    );
                  });
              })
              .catch(res => {
                console.log(error);
                alert(
                  "Erro ao carregar dados de Trading System. Entre em contato com o suporte: " +
                    error
                );
              });
          })
          .catch(res => {
            console.log(error.message);
            alert(
              "Erro ao ajustar banca. Entre em contato com o suporte: " +
                error.message
            );
          });
      }
      if (win == false) {
        this.payoutContinued
          ? (this.payoutContinued = true)
          : (this.payoutContinued = false);
      } else {
        this.payoutContinued = false;
      }
    }
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  created() {
    this.fetchOrders();
    this.fetchLastWeekOrders();
    this.fetchLastWeekOrdersGrafic();
  }
};
</script>
<style>
.card .card-footer {
  line-height: 12px !important;
}
.select-light {
  background-color: #d31717 !important;
}
.select-black {
  color: #11a7d4 !important;
}
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
  .el-loading-spinner .path {
    stroke: #000 !important;
  }
  .el-loading-mask {
    background: transparent !important;
  }
}

ul#candles li {
  float: left;
  display: inline;
  width: 5%;
}
@media (max-width: 480px) {
  ul#candles li {
    width: 25% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Performance.vue